import React from 'react';

import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { selectKycSupportingDocuments } from '@/store/selectors/kycSelectors';
import { KycType } from '@lucky7ventures/bff-types';
import KycDocument from '@/pages/settings/verify/kyc-sections/KycDocument';

export function KycSupportingDocuments(): JSX.Element | null {
  const intl = useIntl();
  const kycSupportingDocuments = useSelector(selectKycSupportingDocuments);

  if (kycSupportingDocuments.length === 0) {
    return null;
  }

  return (
    <>
      {kycSupportingDocuments.map(kyc => (
        <KycDocument
          type={KycType.SourceOfWealthSupportingDocument}
          status={kyc.status}
          acceptedFileTypes={['image/png', 'image/jpeg', 'application/pdf']}
          title={intl.formatMessage({ id: `supportingDocs.header.${kyc.supportingDocTypeId}` })}
          dropzonesMeta={[
            {
              id: kyc.id.toString(),
              minFiles: 1,
              maxFiles: 1,
              errorMessageTranslationKey: 'settings.verify.upload.error.imagesAndPdfOnly.text',
            },
          ]}
          validationErrorMessage={intl.formatMessage({
            id: 'settings.verify.submit.imagesAndPdfOnly.error',
          })}
          key={`kyc-supporting-documents-${kyc.id}`}
        />
      ))}
    </>
  );
}
